import request from '../request';

const restShopService = {
  getById: (id, params) => request.get(`rest/shops/${id}`, { params }),
};

export default restShopService;
